import HttpService from '@/common/services/HttpService'
import type {
  ScreenBaseDTOV2,
  ScreenBaseDTOV3,
  ScreenDTOV3,
  ScreenTypeEnum,
  ScreenField,
  FieldConditionCollection,
  FieldConditionListDTOV1,
  FieldConditionDTOV1,
  ListScreenParamsDTOV3,
} from '@/common/types/screen'

export const getScreensV3 = async (
  includeDeactivated: ListScreenParamsDTOV3['include-deactivated'],
  expand: ListScreenParamsDTOV3['expand'],
): Promise<ScreenBaseDTOV3[]> => {
  const params: Record<string, unknown> = {
    'include-deactivated': includeDeactivated,
    expand: expand?.join(','),
  }
  return HttpService.getData<ScreenBaseDTOV3[]>('/api/v3/screens', {
    params,
  })
}

/**
 * Handle screen activation
 */
export const handleScreenActivation = (code: UUID, active: boolean) => {
  return HttpService.patch(`/api/v2/screens/${code}`, {
    activeToSet: active,
  })
}

/**
 * Get screen by code
 * @param screenCode screen code
 * @returns ScreenDTOV3
 */
export const getScreenByCode = async (screenCode: UUID): Promise<ScreenDTOV3> => {
  return HttpService.getData<ScreenDTOV3>(`/api/v3/screens/${screenCode}`)
}

/**
 * Create new screen
 * @returns created screen
 */
export const createScreen = async (newScreen: { type: ScreenTypeEnum; active: boolean; fields: ScreenField[] }): Promise<ScreenBaseDTOV2> => {
  return HttpService.postData<ScreenBaseDTOV2>('/api/v2/screens', newScreen)
}

/**
 * Update existing screen
 * @returns updated screen
 */
export const updateScreen = async (screenCode: UUID, updateScreenPayload: { active: boolean; fields: ScreenField[] }): Promise<ScreenBaseDTOV2> => {
  return HttpService.putData<ScreenBaseDTOV2>(`/api/v2/screens/${screenCode}`, updateScreenPayload)
}

/**
 * Get screen field conditions
 * @param screenCode screen code
 * @returns FieldConditionCollection
 */
export const getScreenFieldConditions = async (screenCode: UUID): Promise<FieldConditionCollection> => {
  const conditions = await HttpService.getData<FieldConditionListDTOV1>(`/api/v1/screens/${screenCode}/fields-display-conditions`, { raw: true })
  return new Map([...conditions.map((c) => [c.targetFieldCode, c] as [string, FieldConditionDTOV1])])
}
